import React from 'react';

import { flagStyles } from '../settings';

const SvgSK = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4800px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSK;
